import React from 'react';
import { X } from 'lucide-react';
import InvoiceForm from './InvoiceForm';
import { Invoice } from '../types';
import './Modal.css';

interface InvoiceFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGeneratePDF: (invoices: Invoice[]) => void;
}

const InvoiceFormModal: React.FC<InvoiceFormModalProps> = ({ 
  isOpen, 
  onClose, 
  onGeneratePDF
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create Invoice</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          <InvoiceForm onGeneratePDF={onGeneratePDF} />
        </div>
      </div>
    </div>
  );
};

export default InvoiceFormModal;
